<template>
  <div>
    <b-row>
      <b-col tag="main" lg="12" xl="9" order="2" order-xl="1" class="mb-4">
        <div class="bg-white shadow-sm position-relative">
          <div style="min-height:80px" class="p-4">
            <send-first-kudo class="container-top-center-xl shadow" />
          </div>
          <activity-feed :feeds="feeds" :loading="isFeedsLoading">
            <template #send-message="{ close, feed, receiver, receiverName }">
              <send-message-inline-form
                :category="feed.type"
                :receivers="[receiver]"
                :content="sayHiDefaultMessage(receiverName)"
                :feed="feed.id"
                :submitting="submitting[feed.id]"
                :state="state[feed.id]"
                @submit="onSendMessage($event, feed, close)"
                @cancel="close"
              />
            </template>
          </activity-feed>
        </div>
      </b-col>
      <b-col lg="12" xl="3" order="1" order-xl="2">
        <b-row>
          <b-col tag="aside" lg="6" xl="12" class="mb-4">
            <top-priorities :me="true" class="shadow h-100" />
          </b-col>
          <b-col tag="aside" lg="6" xl="12" class="mb-4" v-if="showCheckActivity">
            <check-activity-feed class="shadow h-100" @dismiss="onDismissActivityFeed" />
          </b-col>
          <b-col tag="aside" lg="6" xl="12" class="mb-4" v-if="!profileMe.isComplete">
            <complete-profile :profile="profileMe" class="shadow h-100" />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import statuses from '@/helpers/statuses'
import ActivityFeed from '@/components/ActivityFeed'
import SendMessageInlineForm from '@/components/forms/SendMessageInlineForm.vue'
import { CheckActivityFeed, SendFirstKudo, CompleteProfile, TopPriorities } from './Aside'
import { sayHiDefaultMessage } from '@/helpers/messageContent'

export default {
  name: 'Home',

  computed: {
    ...mapGetters([
      'profileMe',
      'feedsLoading',
      'feeds'
    ]),

    isFeedsLoading() {
      return this.feedsLoading === statuses.LOADING
    }
  },

  data() {
    return {
      showCheckActivity: true,
      submitting: {},
      state: {}
    }
  },

  async mounted() {
    await this.$store.dispatch('fetchFeeds')
  },

  methods: {
    sayHiDefaultMessage(name) {
      return sayHiDefaultMessage(name)
    },

    onSendMessage(data, { id }, close) {
      this.$set(this.submitting, id, true)
      this.$store.dispatch('sendMessage', data)
        .then(() => {
          this.$store.dispatch('hideCanSayHi', id)
          close()
        })
        .catch(errors => this.$set(this.state, id, errors))
        .finally(() => this.$set(this.submitting, id, false))
    },

    onDismissActivityFeed() {
      this.showCheckActivity = false
    }
  },

  components: {
    ActivityFeed,
    SendMessageInlineForm,
    CheckActivityFeed,
    SendFirstKudo,
    CompleteProfile,
    TopPriorities
  }
}
</script>
